/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CategoryListCategoryResponse } from './CategoryListCategoryResponse';

export type CategoryListCategoryResponseApiRespoonse = {
    data?: CategoryListCategoryResponse;
    status?: CategoryListCategoryResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CategoryListCategoryResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

